import { defineStore } from 'pinia';
import { ref } from 'vue';

export enum ModalType {
  MORE_OPTIONS = 'moreOptions',
  DATE_PICKER = 'datePicker',
  FILTERS = 'filters',
}

export const useModalStore = defineStore('modal', () => {
  const openModals = ref<Set<ModalType>>(new Set());

  const isModalOpen = (type: ModalType): boolean => {
    return openModals.value.has(type);
  };

  const openModal = (type: ModalType): void => {
    openModals.value.add(type);
  };

  const closeModal = (type: ModalType): void => {
    openModals.value.delete(type);
  };

  const toggleModal = (type: ModalType): void => {
    if (isModalOpen(type)) {
      closeModal(type);
    } else {
      openModal(type);
    }
  };

  const closeAllModals = (): void => {
    openModals.value.clear();
  };

  return {
    openModals,
    isModalOpen,
    openModal,
    closeModal,
    toggleModal,
    closeAllModals,
  };
});
